export const companySelector = (state: any) => state.stats.company;
export const statsSelector = (state: any) => state.stats;
export const userSelect = (state: any) => state.auth.user;
export const settingsSelector = (state: any) => state.settings;